import React, { useContext, useState } from "react";
import Interactive_Rc from "../../components/support/Interactive_Rc";
import CreateInstallment from "../../components/support/CreateInstallment";
import ViewInstallment from "../../components/support/ViewInstallment";
import Special_Rc from "../../components/support/Special_Rc";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import ReactSelector from "../../components/common/CommonReactSelector";
import { components } from 'react-select';

const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};

const DASHBOARDS = {
    INTERACTIVE_RC: "interactive_rc",
    INSTALLMENT_PLAN: "installment_plan",
    VIEW_INSTALLMENT: "view_installment",
    SPECIAL_RC: "special_rc",
};

const CustomerSupportDashboard = () => {
    const [activeDashboard, setActiveDashboard] = useState(DASHBOARDS.INTERACTIVE_RC);
    const [loading, setLoading] = useState(false);
    const {langMode} = useContext(AppContext)
    const [activity,setActivity] = useState()
    const switchDashboard = (dashboard) => {
        setLoading(true);
        setTimeout(() => {
            setActiveDashboard(dashboard);
            setLoading(false);
        }, 300);
    };

const options = [
    {label : "DCRC Elec", value: "292", orgsId: "2", projId: "2"},
    {label : "DCRC	Water", value: "309", orgsId:"15", projId: "6"},
    {label : "DCRC Elec RAECO", value: "295", orgsId:"16", projId: "4"},
]

const handleActivityChange = async (selectedOption) => {
    try {
      const activityValue = selectedOption?.value;
      const orgid = selectedOption?.orgsId;
      const prjctId = selectedOption?.projId;
      console.log("Selected activity ID:", activityValue);

      if (activityValue) {
        setActivity(activityValue)
      }
        if (orgid) {
            console.log("Selected Org ID:", orgid);
            localStorage.setItem("selectedOrgId", JSON.stringify(orgid));
        }

        if (prjctId) {
            console.log("Selected Project ID:", prjctId);
            localStorage.setItem("projectId", JSON.stringify(prjctId));
        }
    } catch (error) {
      console.error("Error fetching activity:", error);
    }
  };

    return (
        <div className="sm:w-full w-[96%] py-2 bg-gray-50">
            <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col xl:gap-0 lg:gap-0 md:gap-0 gap-6 justify-between w-full py-3">
                <div className="flex items-center gap-5" role="group">
                    <div className="flex gap-y-4 whitespace-nowrap flex-nowrap overflow-x-auto rounded-md">
                        <button
                            type="button"
                            onClick={() => switchDashboard(DASHBOARDS.INTERACTIVE_RC)}
                            className={`px-4 py-2 text-sm font-medium flex items-center gap-2 ${langMode === 'ar' ? 'rounded-r-lg':'rounded-l-lg' }  focus:ring-2 focus:ring-blue-700 transition-all
                ${activeDashboard === DASHBOARDS.INTERACTIVE_RC
                                    ? "bg-[#236DB4] text-white"
                                    : "bg-gray-200 text-gray-600"}`}
                            aria-label="Interactive RC Dashboard"
                        >
                            {translations[langMode].InteractiveRc}
                        </button>
                        <button
                            type="button"
                            onClick={() => switchDashboard(DASHBOARDS.INSTALLMENT_PLAN)}
                            className={`px-4 py-2 text-sm font-medium flex items-center gap-2 focus:ring-2 focus:ring-blue-700 transition-all
                ${activeDashboard === DASHBOARDS.INSTALLMENT_PLAN
                                    ? "bg-[#236DB4] text-white"
                                    : "bg-gray-200 text-gray-600 "}`}
                            aria-label="Create Installment Plan Dashboard"
                        >
                            {translations[langMode].createInstallment}
                        </button>
                        <button
                            type="button"
                            onClick={() => switchDashboard(DASHBOARDS.VIEW_INSTALLMENT)}
                            className={`px-4 py-2 text-sm font-medium flex items-center gap-2 focus:ring-2 focus:ring-blue-700 transition-all
                ${activeDashboard === DASHBOARDS.VIEW_INSTALLMENT
                                    ? "bg-[#236DB4] text-white "
                                    : "bg-gray-200 text-gray-600 "}`}
                            aria-label="View Installment Dashboard"
                        >
                             {translations[langMode].Viewinstallment}
                        </button>
                        <button
                            type="button"
                            onClick={() => switchDashboard(DASHBOARDS.SPECIAL_RC)}
                            className={`px-4 py-2 text-sm font-medium flex items-center gap-2 ${langMode === 'ar' ? 'rounded-l-lg':'rounded-r-lg' } focus:ring-2 focus:ring-blue-700 transition-all
                ${activeDashboard === DASHBOARDS.SPECIAL_RC
                                    ? "bg-[#236DB4] text-white"
                                    : "bg-gray-200 text-gray-600"}`}
                            aria-label="Special RC Dashboard"
                        >
                              {translations[langMode].SpecialRc}
                        </button>
                       
                    </div>
                </div>

                <div className="xl:max-w-[212px] lg:max-w-[212px] md:max-w-[212px] max-w-[90%] sm:mx-0 mx-auto w-full h-auto">
                    <ReactSelector
                        options={options || []}
                        components={Placeholder}
                        placeholder={translations[langMode].Activity}
                        onChange={handleActivityChange}
                        height="38px"
                    />
                </div>
                
            </div>

            <div className="flex w-full mt-3">
                {activeDashboard === DASHBOARDS.INTERACTIVE_RC && <Interactive_Rc activityId={activity} />}
                {activeDashboard === DASHBOARDS.INSTALLMENT_PLAN && <CreateInstallment />}
                {activeDashboard === DASHBOARDS.VIEW_INSTALLMENT && <ViewInstallment />}
                {activeDashboard === DASHBOARDS.SPECIAL_RC && <Special_Rc activityId={activity} />}
            </div>
        </div>
    );
};

export default CustomerSupportDashboard;
